import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "registration-culture-indicators" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "registration-culture-indicators__label" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_6 = { class: "registration-culture-indicators__indicator" };
const _hoisted_7 = { class: "registration-culture--tooltip" };
const _hoisted_8 = { class: "registration-culture-indicators__currency" };
const _hoisted_9 = { class: "registration-culture-indicators__wrapper" };
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = { class: "registration-culture-indicators__label" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_14 = { class: "registration-culture-indicators__indicator--identified" };
const _hoisted_15 = { class: "registration-culture--tooltip" };
const _hoisted_16 = { class: "registration-culture-indicators__currency" };
const _hoisted_17 = { class: "registration-culture-indicators__wrapper" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = { class: "registration-culture-indicators__label" };
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_22 = { class: "registration-culture-indicators__container" };
const _hoisted_23 = { class: "registration-culture-indicators__indicator--identified" };
const _hoisted_24 = ["src"];
const _hoisted_25 = ["value"];
const _hoisted_26 = { class: "registration-culture-indicators__wrapper" };
const _hoisted_27 = ["innerHTML"];
const _hoisted_28 = { class: "registration-culture-indicators__label" };
const _hoisted_29 = ["innerHTML"];
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_31 = { class: "registration-culture-indicators__indicator--unidentified" };
const _hoisted_32 = { class: "registration-culture--tooltip" };
const _hoisted_33 = { class: "registration-culture-indicators__currency" };
const _hoisted_34 = { class: "registration-culture-indicators__wrapper" };
const _hoisted_35 = ["innerHTML"];
const _hoisted_36 = { class: "registration-culture-indicators__label" };
const _hoisted_37 = ["innerHTML"];
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_39 = { class: "registration-culture-indicators__container" };
const _hoisted_40 = { class: "registration-culture-indicators__indicator--unidentified" };
const _hoisted_41 = ["src"];
const _hoisted_42 = ["value"];
import { reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { formatCurrency, formatPercent, formatNumber } from '@/utilities/formatters';
import { fetchIndicators } from '../data/fetchIndicators';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistrationCultureIndicators',
    setup(__props) {
        const store = useStore();
        const selectedDates = computed(() => store.getters.dates);
        watch(selectedDates.value, () => {
            fetchDataIndicators();
        });
        const state = reactive({
            loading: false,
            hasError: false,
        });
        const totalCurrency = reactive({
            revenue_total: '',
            total_revenue_identified: '',
            total_revenue_unidentified_fictitious: '',
        });
        const indicators = reactive({
            data: {
                identified_rate: '',
                unidentified_fictitious_rate: '',
                revenue_total: '',
                total_identified: '',
                total_unidentified_fictitious: '',
                total_orders: '',
                total_revenue_identified: '',
                total_revenue_unidentified_fictitious: '',
            },
        });
        const fetchDataIndicators = async () => {
            state.loading = true;
            await fetchIndicators(selectedDates.value)
                .then(amount => {
                if (amount === null) {
                    indicators.data = null;
                    return;
                }
                const currencyConfig = {
                    shortNumber: true,
                };
                indicators.data.identified_rate = formatPercent(amount.identified_rate / 100);
                indicators.data.unidentified_fictitious_rate = formatPercent(amount.unidentified_fictitious_rate / 100);
                indicators.data.revenue_total = formatCurrency(amount.revenue_total, currencyConfig);
                indicators.data.total_revenue_identified = formatCurrency(amount.total_revenue_identified, currencyConfig);
                indicators.data.total_revenue_unidentified_fictitious = formatCurrency(amount.total_revenue_unidentified_fictitious, currencyConfig);
                indicators.data.total_identified = formatNumber(amount.total_identified);
                indicators.data.total_unidentified_fictitious = formatNumber(amount.total_unidentified_fictitious);
                indicators.data.total_orders = formatNumber(amount.total_orders);
                totalCurrency.revenue_total = formatCurrency(amount.revenue_total);
                totalCurrency.total_revenue_identified = formatCurrency(amount.total_revenue_identified);
                totalCurrency.total_revenue_unidentified_fictitious = formatCurrency(amount.total_revenue_unidentified_fictitious);
            })
                .catch(() => {
                indicators.data = null;
                state.hasError = true;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        fetchDataIndicators();
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_v2, { class: "registration-culture-indicators__card" }, {
                    default: _withCtx(() => [
                        (!state.loading && !state.hasError && indicators.data)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_el_popover, {
                                    trigger: "hover",
                                    placement: "top",
                                    width: 260
                                }, {
                                    reference: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("span", {
                                                innerHTML: _ctx.$t('registration-culture.indicators.total_orders')
                                            }, null, 8, _hoisted_4),
                                            _hoisted_5
                                        ])
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", {
                                            innerHTML: _ctx.$t('registration-culture.tooltips.total-orders'),
                                            class: "registration-culture--tooltip"
                                        }, null, 8, _hoisted_2)
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("strong", _hoisted_6, _toDisplayString(indicators.data.total_orders), 1),
                                _createVNode(_component_el_popover, {
                                    trigger: "hover",
                                    placement: "bottom",
                                    width: 130
                                }, {
                                    reference: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(indicators.data.revenue_total), 1)
                                    ]),
                                    default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(totalCurrency.revenue_total), 1)
                                    ]),
                                    _: 1
                                })
                            ], 64))
                            : _createCommentVNode("", true),
                        (state.loading)
                            ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                            : _createCommentVNode("", true),
                        (!indicators.data && !state.loading)
                            ? (_openBlock(), _createBlock(InfoCard, {
                                key: 2,
                                ref: "message-error",
                                error: state.hasError
                            }, null, 8, ["error"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_component_base_card_v2, { class: "registration-culture-indicators__card-two" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                            (!state.loading && !state.hasError && indicators.data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 260
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("span", {
                                                    innerHTML: _ctx.$t('registration-culture.indicators.total_identified')
                                                }, null, 8, _hoisted_12),
                                                _hoisted_13
                                            ])
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", {
                                                innerHTML: _ctx.$t('registration-culture.tooltips.identified'),
                                                class: "registration-culture--tooltip"
                                            }, null, 8, _hoisted_10)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("strong", _hoisted_14, _toDisplayString(indicators.data.total_identified), 1),
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "bottom",
                                        width: 130
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(indicators.data.total_revenue_identified), 1)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_15, _toDisplayString(totalCurrency.total_revenue_identified), 1)
                                        ]),
                                        _: 1
                                    })
                                ], 64))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (!indicators.data && !state.loading)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: state.hasError
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            (!state.loading && !state.hasError && indicators.data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 260
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("span", {
                                                    innerHTML: _ctx.$t('registration-culture.indicators.identified_rate')
                                                }, null, 8, _hoisted_20),
                                                _hoisted_21
                                            ])
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", {
                                                innerHTML: _ctx.$t('registration-culture.tooltips.percentage-identified'),
                                                class: "registration-culture--tooltip"
                                            }, null, 8, _hoisted_18)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("strong", _hoisted_23, _toDisplayString(indicators.data.identified_rate), 1),
                                        _createElementVNode("img", {
                                            class: "icon",
                                            src: require(`@/assets/img/icons/user-check-01.svg`)
                                        }, null, 8, _hoisted_24)
                                    ]),
                                    _createElementVNode("progress", {
                                        class: "registration-culture-indicators__bar--identified",
                                        value: +indicators.data.identified_rate.replace('%', ''),
                                        max: "100"
                                    }, null, 8, _hoisted_25)
                                ], 64))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (!indicators.data && !state.loading)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: state.hasError
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }),
                _createVNode(_component_base_card_v2, { class: "registration-culture-indicators__card-two" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                            (!state.loading && !state.hasError && indicators.data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 260
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("span", {
                                                    innerHTML: _ctx.$t('registration-culture.indicators.total_unidentified_fictitious')
                                                }, null, 8, _hoisted_29),
                                                _hoisted_30
                                            ])
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", {
                                                innerHTML: _ctx.$t('registration-culture.tooltips.unidentified'),
                                                class: "registration-culture--tooltip"
                                            }, null, 8, _hoisted_27)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("strong", _hoisted_31, _toDisplayString(indicators.data.total_unidentified_fictitious), 1),
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "bottom",
                                        width: 130
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_33, _toDisplayString(indicators.data.total_revenue_unidentified_fictitious), 1)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_32, _toDisplayString(totalCurrency.total_revenue_unidentified_fictitious), 1)
                                        ]),
                                        _: 1
                                    })
                                ], 64))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (!indicators.data && !state.loading)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: state.hasError
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                            (!state.loading && !state.hasError && indicators.data)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 260
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("span", {
                                                    innerHTML: _ctx.$t('registration-culture.indicators.unidentified_fictitious_rate')
                                                }, null, 8, _hoisted_37),
                                                _hoisted_38
                                            ])
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", {
                                                innerHTML: _ctx.$t('registration-culture.tooltips.percentage-unidentified'),
                                                class: "registration-culture--tooltip"
                                            }, null, 8, _hoisted_35)
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("strong", _hoisted_40, _toDisplayString(indicators.data.unidentified_fictitious_rate), 1),
                                        _createElementVNode("img", {
                                            class: "icon",
                                            src: require(`@/assets/img/icons/user-x-01.svg`)
                                        }, null, 8, _hoisted_41)
                                    ]),
                                    _createElementVNode("progress", {
                                        class: "registration-culture-indicators__bar--unidentified",
                                        value: +indicators.data.unidentified_fictitious_rate.replace('%', ''),
                                        max: "100"
                                    }, null, 8, _hoisted_42)
                                ], 64))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                : _createCommentVNode("", true),
                            (!indicators.data && !state.loading)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 2,
                                    ref: "message-error",
                                    error: state.hasError
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
